import React, { useState, useEffect } from "react";
import product from "../../images/igb-key-1.jpg";
import product1 from "../../images/igb-key-2.jpg";
import product2 from "../../images/igb-key-3.jpg";
import { getPaymentUrl } from "../actions/payments";

export default function FoldBoardProductPage() {
  const images = [product, product1, product2];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // change image every 3 seconds

    return () => clearInterval(interval);
  }, []);

  const handlePurchaseClick = async () => {
    const type = "keyboard"; // 🔁 this is your product identifier

    const authStr = localStorage.getItem("auth");
    const authObj = JSON.parse(authStr);
    const token = authObj?.data?.access_token;

    if (!token) {
      alert("User not logged in");
      return;
    }

    try {
      const res = await getPaymentUrl(type, token);
      console.log("✅ Checkout URL received:", res.data.checkoutPageUrl);

      if (res.data.checkoutPageUrl) {
        window.location.href = res.data.checkoutPageUrl;
      }
    } catch (err) {
      console.error("❌ Payment URL error:", err);
      alert("Something went wrong during checkout.");
    }
  };

  return (
    <div className="min-h-screen text-white w-full rounded-2xl card border border-blue-400 font-sans p-6">
      <div className="max-w-6xl  mx-auto">
        {/* Header */}
        <h1 className="text-4xl md:text-6xl text-[#34b2fd] font-bold text-center  my-4">
          Ironglass keyBoard
        </h1>
        <p className="text-center text-lg md:text-xl text-gray-300 mb-10">
          The Ultimate Foldable Keyboard + Touchscreen Companion for
          Professionals on the Go
        </p>

        {/* Product Image */}

        <div className=" p-2">
          {/* Description */}
          <section className="mb-12 text-gray-300">
            <p className="text-lg leading-relaxed">
              The <strong>Ironglass FoldBoard</strong> is a cutting-edge,
              all-in-one input solution designed for engineers, developers, and
              power users who demand maximum control in minimal space. It
              features a fully foldable design for portability, a built-in
              touchscreen display, dual accessory knobs, and a red TrackPoint
              for precision mouse control — all packed into a compact mechanical
              keyboard.
            </p>
            <p className="mt-4 text-lg leading-relaxed">
              Whether you're managing a remote server, booting into a headless
              setup, or simply need a screen and keyboard on the fly, the
              FoldBoard is your go-to tool. Simply unfold it, plug it in, and
              take command instantly.
            </p>
          </section>

          <div className=" flex justify-between ">
            {/* Features Section */}
            <section className="grid md:grid-cols-2 w-1/2 gap-10 mb-12">
              <div>
                <h2 className="text-3xl font-bold text-blue2 mb-4">
                  Key Features
                </h2>
                <ul className="space-y-3 text-gray-300">
                  <li>
                    📺 Built-in touchscreen display with full touch support
                  </li>
                  <li>
                    🧠 Integrated red TrackPoint for precision cursor control
                  </li>
                  <li>
                    🎛️ Dual customizable aluminum knobs for dynamic interaction
                  </li>
                  <li>
                    🧳 Foldable chassis for unmatched portability and
                    convenience
                  </li>
                  <li>
                    🧱 Low-profile mechanical switches for optimal tactile
                    feedback
                  </li>
                  <li>🔌 USB-C connectivity with programmable features</li>
                </ul>
              </div>
              <div className="pr-14">
                <h2 className="text-3xl pr-6 font-bold text-blue2 mb-4">
                  Ideal For
                </h2>
                <ul className="space-y-3 text-gray-300">
                  <li>✔️ Developers and system administrators on the move</li>
                  <li>✔️ Embedded device interfacing and server setups</li>
                  <li>✔️ On-the-go tech professionals and field engineers</li>
                  <li>✔️ Digital minimalists who value versatility</li>
                </ul>
              </div>
            </section>

            <div className=" w-1/2 mb-10">
              <img
                src={images[currentImageIndex]}
                alt="Ironglass FoldBoard"
                className="rounded-2xl border-4  border-blue-400 shadow-lg p-2 w-full max-w-4xl transition-opacity duration-700 ease-in-out"
              />

              <h1 className=" text-2xl text-[#C0C0C0] font-bold mx-2  p-2 ">
                {" "}
                Product :{" "}
                <span className="text-blue2">Ironglass Byte Keyboard</span>{" "}
              </h1>
              <h1 className=" text-2xl font-bold text-[#C0C0C0] mx-2  p-2 ">
                {" "}
                Price : <span className="text-blue2">80$</span>{" "}
              </h1>
            </div>
          </div>

          {/* Call to Action */}
          <div className="text-center">
            <h2 className="text-3xl font-bold mb-4">Reserve Your FoldBoard</h2>
            <p className="text-gray-400 mb-6">
              Limited units available for early adopters. Preorder now and
              experience the freedom of portable productivity.
            </p>
            <button
              onClick={handlePurchaseClick}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl font-semibold shadow-md"
            >
              Order Now - $80
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
